import XUIBanner, { XUIBannerAction, XUIBannerActions, XUIBannerMessage } from '@xero/xui/react/banner';
import { FC } from 'react';
import { IErrorBannerModel } from './ErrorBannerModel';

interface IErrorBannerProps {
    error: IErrorBannerModel;
    qaHook?: string;
}

export const ErrorBanner: FC<IErrorBannerProps> = ({error, qaHook }) => {
    return (
        <XUIBanner
            qaHook={qaHook}
            sentiment={'negative'}
            className='xui-margin-bottom-2xlarge'
        >
            <div className='xui-u-flex xui-u-flex-align-end'>
            <XUIBannerMessage className='xui-u-flex-row xui-u-fullwidth'>
                {error.message}
            </XUIBannerMessage>
            <XUIBannerActions className='xui-u-flex-none' >
                <XUIBannerAction qaHook={qaHook}
                                 onClick={error.actionButtonOnClickAction ?? undefined}
                                 isLink={!!error.actionButtonHref }
                                 href={error.actionButtonHref}>
                    {error.actionButtonText}
                </XUIBannerAction>
            </XUIBannerActions>
            </div>
        </XUIBanner>
    );
}

